import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { sortOptionsAndVariations } from "@faire/web--source/common/products/sortOptionsAndVariations";
import { protoValues } from "@faire/web--source/common/typescriptUtils";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import { IProductOption } from "@faire/web-api--source/indigofair/data/IProductOption";
import { IProductPageResponse } from "@faire/web-api--source/indigofair/data/IProductPageResponse";
import { IUserTranslatedString } from "@faire/web-api--source/indigofair/data/IUserTranslatedString";
import { ILocaleKey } from "@faire/web-api--source/indigofair/locale/ILocaleKey";
import isUndefined from "lodash/isUndefined";
export var getProductName = function(product) {
    var _product_name, _product_name1;
    var _product_name_translated;
    return (_product_name_translated = product === null || product === void 0 ? void 0 : (_product_name = product.name) === null || _product_name === void 0 ? void 0 : _product_name.translated) !== null && _product_name_translated !== void 0 ? _product_name_translated : product === null || product === void 0 ? void 0 : (_product_name1 = product.name) === null || _product_name1 === void 0 ? void 0 : _product_name1.original;
};
export var getProductDescription = function(product) {
    var _product_details_description, _product_details, _product_details_description1, _product_details1;
    var _product_details_description_translated;
    return (_product_details_description_translated = product === null || product === void 0 ? void 0 : (_product_details = product.details) === null || _product_details === void 0 ? void 0 : (_product_details_description = _product_details.description) === null || _product_details_description === void 0 ? void 0 : _product_details_description.translated) !== null && _product_details_description_translated !== void 0 ? _product_details_description_translated : product === null || product === void 0 ? void 0 : (_product_details1 = product.details) === null || _product_details1 === void 0 ? void 0 : (_product_details_description1 = _product_details1.description) === null || _product_details_description1 === void 0 ? void 0 : _product_details_description1.original;
};
export var getProductOptions = function(product) {
    if (isUndefined(product) || isUndefined(product.options)) {
        return [];
    }
    var options = protoValues(product.options);
    return options;
};
export var getSortedProductOptions = function(product) {
    if (isUndefined(product) || isUndefined(product.options)) {
        return [];
    }
    var productDetails = getProductDetails(product);
    sortOptionsAndVariations(productDetails);
    return productDetails.options;
};
export var getProductOptionMap = function(product) {
    return product.options.reduce(function(acc, option) {
        if (option.token) {
            acc[option.token] = IProductOption.build(option);
        }
        return acc;
    }, {});
};
export var getProductDetails = function(product, brandToken) {
    var _product_visuals, _product_purchase_information, _product_purchase_information1, _product_purchase_information2, _product_purchase_information_non_returnable_reason_data, _product_purchase_information3, _product_purchase_information4, _product_purchase_information5, _product_purchase_information6, _product_purchase_information7, _product_purchase_information8, _product_purchase_information9;
    return IProduct.build({
        brand_token: brandToken,
        description: getProductDescription(product),
        options: getProductOptions(product),
        images: (_product_visuals = product.visuals) === null || _product_visuals === void 0 ? void 0 : _product_visuals.images,
        allow_sales_when_out_of_stock: (_product_purchase_information = product.purchase_information) === null || _product_purchase_information === void 0 ? void 0 : _product_purchase_information.allow_sales_when_out_of_stock,
        unit_multiplier: (_product_purchase_information1 = product.purchase_information) === null || _product_purchase_information1 === void 0 ? void 0 : _product_purchase_information1.unit_multiplier,
        per_style_min_order_quantity: (_product_purchase_information2 = product.purchase_information) === null || _product_purchase_information2 === void 0 ? void 0 : _product_purchase_information2.per_style_min_order_quantity,
        non_returnable_reason: (_product_purchase_information3 = product.purchase_information) === null || _product_purchase_information3 === void 0 ? void 0 : (_product_purchase_information_non_returnable_reason_data = _product_purchase_information3.non_returnable_reason_data) === null || _product_purchase_information_non_returnable_reason_data === void 0 ? void 0 : _product_purchase_information_non_returnable_reason_data.non_returnable_reason,
        name: getProductName(product),
        token: product.token,
        board_tokens: product.board_tokens,
        is_high_sell_through: (_product_purchase_information4 = product.purchase_information) === null || _product_purchase_information4 === void 0 ? void 0 : _product_purchase_information4.is_high_sell_through,
        state: product.state,
        customizations: (_product_purchase_information5 = product.purchase_information) === null || _product_purchase_information5 === void 0 ? void 0 : _product_purchase_information5.customizations,
        max_option_wholesale_price: (_product_purchase_information6 = product.purchase_information) === null || _product_purchase_information6 === void 0 ? void 0 : _product_purchase_information6.max_option_wholesale_price,
        max_option_retail_price: (_product_purchase_information7 = product.purchase_information) === null || _product_purchase_information7 === void 0 ? void 0 : _product_purchase_information7.max_option_retail_price,
        preorderable: (_product_purchase_information8 = product.purchase_information) === null || _product_purchase_information8 === void 0 ? void 0 : _product_purchase_information8.is_preorderable,
        is_highlighted_product_for_promotional_event: product.is_highlighted_product_for_promotional_event,
        variation_map: (_product_purchase_information9 = product.purchase_information) === null || _product_purchase_information9 === void 0 ? void 0 : _product_purchase_information9.variation_map
    });
};
export var getPdpProductFromProduct = function(product) {
    return IProductPageResponse.IPdpProduct.build({
        token: product.token,
        name: IUserTranslatedString.build({
            original: product.name
        }),
        options: getProductOptionMap(product),
        state: product.state,
        board_tokens: product.board_tokens,
        is_promoted: product.is_promoted,
        promoted_by: product.promoted_by,
        is_highlighted_product_for_promotional_event: product.is_highlighted_product_for_promotional_event,
        visuals: IProductPageResponse.IPdpProduct.IVisuals.build({
            images: product.images
        }),
        purchase_information: IProductPageResponse.IPdpProduct.IPurchaseInformation.build({
            order_by_date: product.order_by_date,
            unit_multiplier: product.unit_multiplier,
            tester_price: product.tester_price,
            tester_promo_price: product.tester_promo_price,
            tester_prices: product.tester_prices,
            min_order_quantity: product.min_order_quantity,
            per_style_min_order_quantity: product.per_style_min_order_quantity,
            product_orderability_counts: product.product_orderability_counts,
            non_returnable_reason_data: product.non_returnable_reason_data,
            style_groups: product.style_groups,
            variation_map: product.variation_map,
            customizations: product.customizations,
            is_high_sell_through: product.is_high_sell_through,
            is_new: product.is_new,
            allow_sales_when_out_of_stock: product.allow_sales_when_out_of_stock,
            max_option_retail_price: product.max_option_retail_price,
            max_option_wholesale_price: product.max_option_wholesale_price,
            has_pre_packs_available: product.has_pre_packs_available,
            is_preorderable: product.preorderable
        }),
        details: IProductPageResponse.IPdpProduct.IDetails.build({
            taxonomy_type: product.taxonomy_type,
            description: IUserTranslatedString.build({
                translated: product.description
            }),
            product_information_section_groups: [
                IProductPageResponse.IPdpProduct.IDetails.IProductInformationSectionGroup.build({
                    type: "PRODUCT_INFORMATION",
                    sections: [
                        IProductPageResponse.IPdpProduct.IDetails.IProductInformationSubSection.build({
                            type: "DESCRIPTION",
                            entries: [
                                IProductPageResponse.IPdpProduct.IDetails.IProductInformationSubSection.IProductInformationSubSectionEntry.build({
                                    text: IUserTranslatedString.build({
                                        translated: product.description
                                    })
                                })
                            ]
                        })
                    ]
                })
            ],
            made_in: IUserTranslatedString.build({
                original: product.made_in_country,
                original_locale_key: ILocaleKey.build({
                    country: product.made_in_country
                })
            })
        }),
        shipping_information: IProductPageResponse.IPdpProduct.IShippingInformation.build({
            expected_ship_date: product.expected_ship_date,
            expected_ship_window_days: product.expected_ship_window_days,
            has_mixed_ship_dates: product.has_mixed_ship_dates
        })
    });
};
export function isMixedProduct(product) {
    var _productOptions_, _productOptions_1, _productOptions_2, _productOptions_3;
    var productOptions = getProductOptions(product);
    if (!productOptions.length) {
        return false;
    }
    var type = (_productOptions_ = productOptions[0]) === null || _productOptions_ === void 0 ? void 0 : _productOptions_.orderability_type;
    var startDate = (_productOptions_1 = productOptions[0]) === null || _productOptions_1 === void 0 ? void 0 : _productOptions_1.expected_ship_date;
    var shipWindowDays = (_productOptions_2 = productOptions[0]) === null || _productOptions_2 === void 0 ? void 0 : _productOptions_2.expected_ship_window_days;
    var stopSellingAt = (_productOptions_3 = productOptions[0]) === null || _productOptions_3 === void 0 ? void 0 : _productOptions_3.stop_selling_at;
    return productOptions.some(function(option) {
        return option.orderability_type !== type || option.expected_ship_date !== startDate || option.expected_ship_window_days !== shipWindowDays || option.stop_selling_at !== stopSellingAt;
    });
}
export var getShowroomProductData = function(product) {
    var pdpProduct = getPdpProductFromProduct(product);
    return IProductPageResponse.IPdpProduct.build(_object_spread_props(_object_spread({}, pdpProduct), {
        purchase_information: IProductPageResponse.IPdpProduct.IPurchaseInformation.build(_object_spread_props(_object_spread({}, pdpProduct.purchase_information), {
            is_mid_price_point_brand_apparel_product: true
        })),
        visuals: IProductPageResponse.IPdpProduct.IVisuals.build(_object_spread_props(_object_spread({}, pdpProduct.visuals), {
            show_vertical_image: true
        }))
    }));
};
